<template>
  <div class="pa-4">
    <v-data-table
      :headers="headers"
      :items="certs"
      :loading="is_loading"
      :server-items-length="itemsLength"
      :items-per-page="limit"
      no-data-text="مدرکی یافت نشد"
      @update:page="init({ page: $event })"
      @update:items-per-page="init({ limit: $event })"
      :footer-props="{
        'items-per-page-options': [5, 10, 15, 20],
        'items-per-page-text': 'آیتم در صفحه:',
      }"
      item-key="queryId"
      class="elevation-1"
    >
      <template v-slot:[`footer.page-text`]="items">
        {{ items.pageStart }} - {{ items.pageStop }} از {{ items.itemsLength }}
      </template>
      <template v-slot:item.createMoment="{ item }">
        {{ $_date(item.createMoment) }}
      </template>
      <template v-slot:item.queryId="{ item }">
        {{ enToFa(item.queryId) }}
      </template>
      <template v-slot:item.level="{ item }">
        {{ $_t(`attribute.${item.level}`) }}
      </template>
      <template v-slot:item.howToSend="{ item }">
        {{ $_t(`attribute.${item.howToSend}`) }}
      </template>
      <template v-slot:item.state="{ item }">
        {{ $_t(`attribute.${item.state}`) }}
      </template>
      <template v-slot:item.isPay="{ item }">
        <v-icon color="success" v-if="item.isPay">mdi-check-bold</v-icon>
        <v-icon v-else color="red">mdi-close-thick</v-icon>
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="" v-if="$vuetify.breakpoint.width < 960">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark v-bind="attrs" v-on="on">
                عملیات
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-if="!item.isPay" @click="openModal(item)">
                <v-list-item-icon>
                  <v-icon>mdi-cash</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{
                    $_t("attribute.pay")
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="item.state === 'New'" @click="edit(item)">
                <v-list-item-icon>
                  <v-icon>mdi-pencil</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{
                    $_t("attribute.edit")
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-if="item.certificatePhoto"
                @click="showCertificate(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-certificate</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{
                    $_t("attribute.pay")
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="showItem(item)">
                <v-list-item-icon>
                  <v-icon>mdi-map-marker-star</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    ><span>مشاهده ی اطلاعت پستی</span></v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <div class="" v-else>
          <!--      pay modal  -->
          <v-tooltip bottom v-if="!item.isPay">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                color="success"
                v-on="on"
                class="ml-1"
                @click="openModal(item)"
              >
                <v-icon>mdi-cash</v-icon>
              </v-btn>
            </template>
            <span>{{ $_t("attribute.pay") }}</span>
          </v-tooltip>
          <!--  edit certificate  -->
          <v-tooltip bottom v-if="item.state === 'New'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                color="orange"
                v-on="on"
                class="ml-1"
                @click="edit(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>{{ $_t("attribute.edit") }}</span>
          </v-tooltip>
          <!--       see user certificate  -->
          <v-tooltip bottom v-if="item.certificatePhoto">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                color="primary"
                v-on="on"
                class="ml-1"
                @click="showCertificate(item)"
              >
                <v-icon>mdi-certificate</v-icon>
              </v-btn>
            </template>
            <span>مشاهده عکس مدرک</span>
          </v-tooltip>
          <!--       see send info -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                @click="showItem(item)"
                v-on="on"
                color="primary"
                target="_blank"
                class="ml-1"
              >
                <v-icon>mdi-map-marker-star</v-icon>
              </v-btn>
            </template>
            <span>مشاهده ی اطلاعت پستی</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
    <v-dialog v-model="showInfoDialog" width="400">
      <v-card tile class="pa-4">
        <v-card-title class="float-end pa-0">
          <v-btn icon @click="showInfoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-spacer></v-spacer>
        <v-card-text class="font-weight-bold">
          نام و نام خانوادگی: {{ item.fullName }}
        </v-card-text>
        <v-card-text class="font-weight-bold">
          آدرس: {{ item.address }}
        </v-card-text>
        <v-card-text class="font-weight-bold">
          کد پستی: {{ item.postalCode }}
        </v-card-text>
        <v-card-text class="pb-0 font-weight-bold"
          >نحوه ارسال: {{ $_t(`attribute.${item.howToSend}`) }}
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--  see certificate and accept or reject  -->
    <v-dialog v-model="showCertificatePictureDialog" width="700">
      <v-container fluid>
        <v-row v-if="item.state !== 'FinalApprovalByUser'">
          <v-col cols="3">
            <v-btn
              :loading="is_loading"
              :disabled="is_loading"
              color="success"
              @click="acceptByUser"
              >تایید</v-btn
            >
          </v-col>
          <v-col cols="6" class="d-flex align-baseline">
            <v-text-field
              label="دلیل رد"
              v-model.trim="reason"
              outlined
              dense
              hide-details="auto"
            ></v-text-field>
            <v-btn
              color="red"
              :loading="is_loading"
              :disabled="is_loading"
              class="mr-2"
              outlined
              @click="rejectByUser"
              >رد</v-btn
            >
          </v-col>
          <v-spacer></v-spacer>
          <v-btn
            icon
            color="grey darken-2"
            class="close-btn"
            @click="showCertificatePictureDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>
        <v-row class="position-relative">
          <v-img :src="item.certificatePhoto"></v-img>
        </v-row>
      </v-container>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { enToFa } from "@/tools/Utils";
import message from "@/tools/Message";
export default {
  name: "CertsTable",
  data: () => ({
    headers: [
      {
        text: "ID جهت استعلام",
        align: "start",
        sortable: false,
        value: "queryId",
      },
      {
        text: "نام و نام خانوادگی",
        align: "start",
        sortable: false,
        value: "fullName",
      },
      {
        text: "کد ملی",
        align: "start",
        sortable: false,
        value: "nationalCode",
      },
      {
        text: "تاریخ ثبت",
        align: "start",
        sortable: false,
        value: "createMoment",
      },
      {
        text: "سطح",
        align: "start",
        sortable: false,
        value: "level",
      },
      {
        text: "رشته و گرایش",
        align: "start",
        sortable: false,
        value: "levelType",
      },
      {
        text: "مبلغ واریزی",
        align: "start",
        sortable: false,
        value: "totalPayAmount",
      },
      {
        text: "پیام ادمین",
        align: "start",
        sortable: false,
        value: "submissionId",
      },
      {
        text: "وضعیت",
        align: "start",
        sortable: false,
        value: "state",
      },
      {
        text: "پرداخت",
        align: "start",
        sortable: false,
        value: "isPay",
      },
      {
        text: "عملیات",
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    search: "",
    limit: 10,
    showInfoDialog: false,
    showCertificatePictureDialog: false,
    item: {},
    reason: "",
  }),
  computed: {
    ...mapGetters({
      certs: "dashboard/get_certs",
      is_loading: "loading/is_loading",
      itemsLength: "pagination/get_items_length",
    }),
  },
  methods: {
    ...mapActions({
      openDialog: "dialog/openDialog",
    }),
    enToFa(str) {
      return enToFa(str);
    },
    async edit(cert) {
      await this.$store.dispatch("dashboard/setCert", cert);
      await this.$router.push({
        name: "dashboard.cert.edit",
        params: { id: cert.certificateId },
      });
    },
    openModal(cert) {
      this.$store.dispatch("dashboard/setCert", cert);
      this.openDialog();
    },
    showCertificate(item) {
      this.item = item;
      this.showCertificatePictureDialog = true;
    },
    async acceptByUser() {
      try {
        const res = await this.$actions.acceptCertificate({
          certificateId: this.item.certificateId,
        });
        if (res) message.success(this.$_t("UPDATE_SUCCESS"));
        this.showCertificatePictureDialog = false;
        await this.init({});
      } catch (e) {
        console.log(e);
      }
    },
    async rejectByUser() {
      try {
        if (this.reason === null || this.reason === "")
          return message.error("لطفا دلیل خود را بنویسید");
        const res = await this.$actions.rejectCertificate({
          certificateId: this.item.certificateId,
          cancelingData: this.reason,
        });
        if (res) message.success(this.$_t("UPDATE_SUCCESS"));
        this.showCertificatePictureDialog = false;
        this.reason = "";
        await this.init({});
      } catch (e) {
        console.log(e);
      }
    },
    async init({ page = 1, limit = this.limit }) {
      this.limit = limit;
      const schema = {
        page: {
          index: page,
          size: limit,
        },
        where: [],
        order: [
          {
            column: "createMoment",
            descending: true,
          },
        ],
      };
      await this.$actions.getCerts(schema);
    },
    showItem(item) {
      this.item = item;
      this.showInfoDialog = true;
    },
  },
  mounted() {
    this.init({});
  },
};
</script>

<style scoped>
.position-relative {
  position: relative;
}
</style>
